import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconSparkleSvg } from "./IconSparkleSvg.mjs";
const IconSparkle = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconSparkleSvg, ...iconProps });
};
export {
  IconSparkle
};
